import React from "react";
import ProductSlider6 from "../../components/Sliders/ProductSliders/ProductSlider6/ProductSlider6";
import ProductSlider3 from "../../components/Sliders/ProductSliders/ProductSlider3/ProductSlider3";
import Benefits from "../../components/Benefits/Benefits";
import BannerRow2 from "../../components/BannerRow2/BannerRow2"; // Import BannerRow2
import Newsletter from "../../components/Newsletter/Newsletter"; // Import Newsletter component
import PartnerPromo from "../../components/PartnerPromo/PartnerPromo"; // Import PartnerPromo

// Map each component type to its respective React component
const componentMap: any = {
  ProductSlider6,
  ProductSlider3,
  Benefits,
  BannerRow2, // Add BannerRow2 to the component map
  Newsletter, // Add Newsletter to the component map
  PartnerPromo, // Add PartnerPromo to the component map
};

interface DynamicComponentRendererProps {
  component: any;
}

export const DynamicComponentRenderer: React.FC<
  DynamicComponentRendererProps
> = ({ component }) => {
  const ComponentToRender = componentMap[component.type];

  if (!ComponentToRender) return null;

  switch (component.type) {
    case "ProductSlider6":
      return (
        <ComponentToRender
          title={component.title || ""}
          subtitle={component.subtitle || ""}
          products={Array.isArray(component.products) ? component.products : []}
          viewAll={component.viewAll || false}
          url={component.url || ""}
          banner={component.banner || {}}
          bannerTitle={component.bannerTitle || ""}
          bannerSubtitle={component.bannerSubtitle || ""}
          bannerButton={component.bannerButton || ""}
        />
      );

    case "ProductSlider3":
      // Add debug log to see what banner data is being passed
      console.log("Banner data for ProductSlider3:", component.banner);

      return (
        <ComponentToRender
          title={component.title || ""}
          subtitle={component.subtitle || ""}
          products={Array.isArray(component.products) ? component.products : []}
          viewAll={component.viewAll || false}
          url={component.url || ""}
          banner={{
            title: component.banner?.title || "",
            subtitle: component.banner?.subtitle || "",
            buttonText: component.banner?.buttonText || "",
            image: component.banner?.image || "",
            url: component.banner?.url || "",
            urlMetaTitle:
              component.banner?.urlMetaTitle || component.banner?.title || "", // Add urlMetaTitle
          }}
        />
      );

    case "Benefits":
      console.log("HomeMapper passing to Benefits component:", {
        sectionTitle: component.sectionTitle || "",
        itemsCount: Array.isArray(component.items) ? component.items.length : 0,
        itemsData: Array.isArray(component.items) ? component.items : [],
      });
      return (
        <ComponentToRender
          sectionTitle={component.sectionTitle || ""}
          items={Array.isArray(component.items) ? component.items : []}
        />
      );

    case "BannerRow2":
      return (
        <ComponentToRender
          banners={Array.isArray(component.banners) ? component.banners : []}
        />
      );

    case "Newsletter":
      return (
        <ComponentToRender
          title={component.title || ""}
          text={component.text || ""}
          buttonText={component.buttonText || "Subscribe"}
          iconUrl={component.iconUrl}
        />
      );

    case "PartnerPromo":
      return (
        <ComponentToRender
          partnerQuantity={component.partnerQuantity || 100}
          partnerQuantityText={component.partnerQuantityText || "Partners"}
          title={component.title || ""}
          text={component.text || ""}
          buttonText={component.buttonText || ""}
          buttonUrl={component.buttonUrl || ""}
        />
      );

    default:
      return <ComponentToRender {...component} />;
  }
};
